module.exports = __webpack_public_path__ + "static/media/loading.984381ca.gif";